import Combobox from '@ls/react-combobox-grid';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useBetaDecodesQuery} from 'state/betas/hooks';
import {Cell, Grid} from 'styled-css-grid';
import {scaleTypeOptions} from 'state/Constants/ScaleType';
const covarianceOptions = [    
  {
    label: 'HIST',
    value: 'Historical',
  },
  {
    label: 'REGIME/ SHORT',
    value: 'Short',
  }
]; 
const betaFactorOptions = [{label: 'TOTAL', value: 'TOTAL'}];


const BetaSelectorComplication = ({setDefinition, definition}) => {
  const {data: betaQueryData, fetching: betaQueryFetching} = useBetaDecodesQuery();
  const betaOptions = betaQueryData?.betaOptions;

 
  const [setBetaId, setBetaFactor,setCovarianceType, setScaleType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setBetaId(value)),
      (value) => setDefinition(definition.setBetaFactor(value)),
      (value) => setDefinition(definition.setCovarianceType(value)),
      (value) => setDefinition(definition.setScaleType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={2}>
        <Combobox
          label="Beta:"
          labelPosition="TOP"
          value={definition.betaId}
          options={betaOptions}
          loading={betaQueryFetching}
          placeholder="Select Beta..."
          onChange={setBetaId}
          size={'S'}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Covariance:"
          labelPosition={'TOP'}
          value={definition.covarianceType}
          options={covarianceOptions}
          onChange={setCovarianceType}
          gridHeight={100}
          size={'S'}
          variation={0}
          clearable={false}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Factor:"
          labelPosition="TOP"
          size={'S'}
          value={definition.betaFactor}
          options={betaFactorOptions}
          onChange={setBetaFactor}
          gridHeight={100}
          variation={0}
          clearable={false}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Type:"
          size={'S'}
          value={definition.scaleType}
          options={scaleTypeOptions}
          onChange={setScaleType}
          gridHeight={120}
          variation={0}
          clearable={false}
        />
      </Cell>
    </Grid>
  );
};

BetaSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(BetaSelectorComplication);
